import { selectRouteNestedParams } from '@ebeihilfe/core';
import { FormDocument } from '@ebeihilfe/einreichung-shared/model';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { EINREICHUNG_STORE_KEY } from '../reducers';
import { EinreichungState } from '../reducers/einreichung.reducer';

const getEinreichungState = createFeatureSelector<EinreichungState>(EINREICHUNG_STORE_KEY);

export const selectContainerDetailsData = createSelector(
  getEinreichungState,
  (state: EinreichungState) => state.containerDetails.data,
);

export const selectContainerDetailsLoading = createSelector(
  getEinreichungState,
  (state: EinreichungState) => state.containerDetails.loading,
);

export const selectContainerDetailsError = createSelector(
  getEinreichungState,
  (state: EinreichungState) => state.containerDetails.error,
);

export const selectFormById = createSelector(
  getEinreichungState,
  selectRouteNestedParams, // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: EinreichungState, nestedParams: any) => {
    const documents = state.containerDetails.data?.documents.filter(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (document: any) => document.formId === nestedParams.formId,
    );

    return !documents ? null : documents[0];
  },
);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectNotMandatoryDocuments = createSelector(selectContainerDetailsData, (state: any) =>
  state?.documents.filter((document: FormDocument) => document.isMandatory === false),
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectMandatoryDocuments = createSelector(selectContainerDetailsData, (state: any) =>
  state?.documents.filter((document: FormDocument) => document.isMandatory),
);
